import {SVGProps} from 'react';

import {COLORS} from '@/styles/colors';

export const AlertIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? '1em'}
    height={props.height ?? '1em'}
    fill="none"
    viewBox="0 0 20 20"
    {...props}>
    <path
      fill={props.color ?? COLORS.INFO_BLUE}
      d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0Zm0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1Zm1-8H9V5h2v2Z"
    />
  </svg>
);
